import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import { HomePage } from "./pages/HomePage";
import { AboutPage } from "./pages/AboutPage";
import { ContactPage } from "./pages/ContactPage";
import { GstRegistrationPage } from "./pages/GstRegistrationPage";
import { GstFilingPage } from "./pages/GstFilingPage";
import { ItrFilingPage } from "./pages/ItrFilingPage";
import { IncomeTaxCalculatorPage } from "./pages/IncomeTaxCalculatorPage";
import { TdsCalculatorPage } from "./pages/TdsCalculatorPage";
import { GstLateFeesCalculatorPage } from "./pages/GstLateFeesCalculatorPage";
import { BusinessRegistrationPage } from "./pages/BusinessRegistrationPage";
import { OtherServicesPage } from "./pages/OtherServicesPage";
import { AdminLoginPage } from "./pages/AdminLoginPage";
import { AdminDashboardPage } from "./pages/AdminDashboardPage";
import { WhatsAppButton } from "./components/WhatsAppButton";
import { Toaster } from "./components/ui/sonner";

// Layout wrapper to conditionally show Navbar/Footer
const Layout = ({ children }) => {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');
  
  return (
    <>
      {!isAdminRoute && <Navbar />}
      <main>{children}</main>
      {!isAdminRoute && <Footer />}
      {!isAdminRoute && <WhatsAppButton />}
    </>
  );
};

function App() {
  return (
    <div className="App bg-navy-900 min-h-screen">
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/gst-registration" element={<GstRegistrationPage />} />
            <Route path="/gst-filing" element={<GstFilingPage />} />
            <Route path="/itr-filing" element={<ItrFilingPage />} />
            <Route path="/income-tax-calculator" element={<IncomeTaxCalculatorPage />} />
            <Route path="/tds-calculator" element={<TdsCalculatorPage />} />
            <Route path="/gst-late-fees-calculator" element={<GstLateFeesCalculatorPage />} />
            <Route path="/business-registration" element={<BusinessRegistrationPage />} />
            <Route path="/other-services" element={<OtherServicesPage />} />
            <Route path="/admin" element={<AdminLoginPage />} />
            <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
          </Routes>
        </Layout>
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
